import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-sm text-slate-500 font-mono">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role) {
    // Admin can access all investor routes
    const allowed = role === user.role || (role === "landlord" && user.role === "admin");
    if (!allowed) {
      return <Navigate to={user.role === "tenant" ? "/tenant" : "/dashboard"} replace />;
    }
  }
  return children;
}
